<template>
	<div class="">
		<!-- filter -->
		<v-row class="mx-1 mb-1">
			<!-- city region filter -->
			<!-- when customer required -->
			<v-col lg="4" md="5" sm="7" cols="12" class="px-1 pb-0">
				<v-row class="pa-3 pa-3 d-flex justify-space-between">
					<!-- cities -->
					<v-col cols="5" class="pa-0 pe-1 d-flex">
						<v-icon class="me-2" size="28"> mdi-map-marker-multiple </v-icon>
						<v-autocomplete
							v-model="cityId"
							:items="cities"
							item-text="name"
							item-value="id"
							:label="$t('inputs.city')"
							dense
							hide-details
							append-icon
							@change="setRegions(); searchCityId = null; type = null"
							:disabled="loading"
							outlined
							multiple
							:search-input.sync="searchCityId"
							clearable
						>
							<template v-slot:prepend-item>
								<v-list-item
									ripple
									@click="toggleCities"
								>
									<v-list-item-action>
										<v-icon>
											{{ iconCities }}
										</v-icon>
									</v-list-item-action>
									
									<v-list-item-content>
										<v-list-item-title>
											{{$t('select-all')}}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-divider class="mt-2"></v-divider>
							</template>

							<template v-slot:selection="{ item, index }">
								<span v-if="index === 0" class="me-1">{{ item.name }}</span>
								<span
									v-if="index === 1"
									class="grey--text text-caption"
								>
									(+{{ cityId.length - 1 }})
								</span>
							</template>   
						</v-autocomplete>
					</v-col>

					<!-- region -->
					<v-col cols="7" class="pa-0">
						<v-autocomplete
							v-model="regionIds"
							:items="regionsAll.filter(c => cityId.includes(c.cityId))"
							item-text="name"
							item-value="id"
							:label="managementHierarchyRegions ? this.$t('inputs.areas') : this.$t('inputs.region')"
							dense
							multiple
							clearable
							hide-details
							:loading="regionsLoading"
							:disabled="loading || regionsLoading || cityId === []"
							outlined
							:search-input.sync="searchRegionId"
							@change="searchRegionId = null; type = null"
						>
							<template v-slot:prepend-item v-if="regions">
								<v-list-item ripple @click="toggleReignsFilterItems">
									<v-list-item-action>
										<v-icon>
											{{ icon }}
										</v-icon>
									</v-list-item-action>
									
									<v-list-item-content>
										<v-list-item-title>
											{{$t('select-all')}}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-divider class="mt-2"></v-divider>
							</template>
							<template v-slot:selection="{ item, index }">
								<span v-if="index === 0" class="me-1">{{ item.name }}</span>
								<span
									v-if="index === 1"
									class="grey--text text-caption"
								>
									(+{{ regionIds.length - 1 }})
								</span>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
			</v-col>

			<!-- type -->
            <!-- <v-col
            	cols="12"
            	md="2"
            	sm="3"
            	align-self="center"
            	class="px-1 pb-0"
            >
                <v-autocomplete
                    v-model="typeAccount"
                    :items="accountType"
                    item-text="name"
                    item-value="accountId"
                    :label="$t('inputs.type')"
                    outlined
                    dense
                    hide-details="auto"
                    @change="getName()"
                    :loading="loading"
                    :disabled="submitLoading || loading"
                    prepend-icon="mdi-account-tie"
                />
            </v-col> -->

			<!-- type account -->
			<v-col cols="12" sm="3" md="2" class="px-1 pb-0">
				<v-autocomplete 
					v-model="type"
					:items="customersTypes"
					item-text="name"
					item-value="id"
					:label="$t('inputs.type')"
					outlined
					hide-details
					dense
					:disabled="loading || submitLoading"
					:loading="loading"
					@change="fetchAccountCustomerByType()"
					clearable
				/>
			</v-col>
	
			<!-- account -->
			<v-col 
				cols="12" 
				lg="2" 
				md="3" 
				sm="4" 
				align-self="center" 
                class="px-1 pb-0"
			>
                <v-autocomplete
                    v-model="name"
                    :items="accountsBrief"
                    item-text="name"
                    item-value="accountId"
                    :label="$t('inputs.name')"
                    outlined
                    dense
                    hide-details
                    :loading="loading || submitLoading"
                    :disabled="submitLoading || loading"
					clearable
               />
            </v-col>  

			<!-- materials -->
			<v-col cols="12" sm="3"  md="2"  class="px-1 pb-0">
				<v-autocomplete 
					v-model="materialId"
					:items="materials"
					item-text="name"
					item-value="id"
					:label="$t('inputs.item')"
					outlined
					hide-details
					dense
					:disabled="loading || submitLoading"
					:loading="loading"
					clearable
				/>
			</v-col>    

			<!-- classifications -->
			<v-col cols="12" sm="3" md="2" class="px-1 pb-0">
				<v-autocomplete
					:label="$t('inputs.class')"
					v-model="workloadIds"
					:items="classification"
					item-text="name"
					item-value="id"
					clearable
					outlined
					dense
					hide-details="auto"
					multiple
					:disabled="loading || submitLoading"
					:loading="loading"
				></v-autocomplete>
			</v-col>
			<!-- <v-spacer v-if="typeAccount !== accountTypeValue.customer" /> -->
			<v-col cols="12" sm="3" md="2" class="px-1 pb-0">
				<!-- date -->
				<bee-date-picker
					v-model="fromDate" 
					:input-label="$t('inputs.start-date')"
					elevation="2"
					menu-picker
					dense
					hide-details
					:input-props="{
						outlined: true,
						dense: true,
						loading: submitLoading || loading,
						prependIcon: 'mdi-calendar'
					}"
					min="1940-01-01"
					:disabled="loading || submitLoading"
					:allowed-dates="disableDates"
				/>
			</v-col>

			<!-- to date -->
			<v-col cols="12" sm="3" md="2" class="px-1 pb-0"> 
				<!-- date -->
				<bee-date-picker
					v-model="toDate" 
					:input-label="$t('inputs.end-date')"
					elevation="2"
					menu-picker
					dense
					hide-details
					:input-props="{
						outlined: true,
						dense: true,
						loading: submitLoading || loading
					}"
					min="1940-01-01"
					:disabled="loading || Boolean($route.query.preview) || submitLoading"
					:allowed-dates="disableDates"
				/>
			</v-col>

			<v-col class="d-flex py-0" align-self="center" >
                <v-btn
                    v-if="excelFile"
                    small
                    color="green lighten-1 white--text"
                    @click="importExcel"
                    class="mx-1"
                    :loading="loadingExcel"
                    :disabled="loadingExcel"
                >
                    <v-icon> mdi-file-table-outline </v-icon>
					{{$t('export-excel')}}
                </v-btn>
            </v-col>

			<!-- actions -->
			<v-spacer  />
			<v-col cols="auto" class="px-0 px-md-3 pb-0">
				<v-btn
					color="success"
					class="px-sm-2 mx-2"
					:loading="loading"
					small
					:disabled="loading || (name === null || type === null)"
					@click="isSearch = true; getStatistics()"
				>
					<v-icon> mdi-magnify </v-icon>
					{{ $t('search') }}
				</v-btn>

				<v-btn
					color="alert-color white--text"
					class="px-sm-4"
					:disabled="loading || !isSearch"
					small
					@click="reset()"
				>
					{{ $t('cancel') }}
				</v-btn>
			</v-col>
		</v-row>
		
		<bee-handy-table
			v-if="isSearch"
			:items="!loading ? items : []"
			:headers="headers"
			class="mt-4"
			dense
			:items-per-page="-1"
			zebra
			:height="$vuetify.breakpoint.height - 270"
			hide-default-footer
			pagination-on-scroll
			:loading="loading"
			:shown-rows-text="$t('shown-rows')"
		></bee-handy-table>

		<!-- footer -->
		<v-footer
			v-if="items.length"
        	padless
        	color="grey lighten-3"
        >
            <!-- <v-spacer/>	 -->
			<v-col
				class="text-center"
                cols="12"
			>
				{{$t('WarehousesStatistics.total-quantities')}} :
				{{ items.map(c => c.totalIn).reduce((a,b) => a + b) }}
			</v-col>
            <!-- <p class="text-body-2 font-weight-bold">
            </p>
            <v-spacer/>
			<v-spacer /> -->
        </v-footer>

		<div
			v-if="!isSearch"
			class="d-flex flex-column justify-center align-center"
			:style="{ height: `${$vuetify.breakpoint.height - 210}px` }"
		>
			<template>
				<v-icon size="60" class="mb-1">mdi-invoice-list</v-icon>
				<span class="text-h6">{{$t('WarehousesStatistics.please-select-account-filter')}}</span>
			</template>
		</div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment'
import { accountType, accountTypeValue } from '@/helpers/enums';
import { managementHierarchyRegions, excelFile, isDisabledFriday, enableCustomerType } from '@/configs/global.config'
import { disableDates } from '@/helpers/functions'

export default {
	watch: {
		type(val) {
			if (val === null) {
				this.accountsBrief = []; 
				this.name = null
			} 
		}
	},
	data () {
		return {
			// filter
			cityId: [],
			regionIds: [],
			fromDate: null,
			toDate: null,
			type: null,
			materialId: null,
			workloadIds: [],
			searchCityId: null,
			searchRegionId: null,
			accounts: [],

			loading: false,
			submitLoading: false,
			regionsLoading: false,

			items: [],
			isSearch: false,
			tab: 0,
			item: null,
			name: null,
			// config (global) 
			excelFile,
			accountsBrief: [],
			accountTypeValue,
			managementHierarchyRegions,
			accountType,
			isDisabledFriday,
			disableDates,
			enableCustomerType
		}
	},

	computed: {
		...mapState({
			cities: state => state.cities.cities,
			regionsAll: state => state.regions.regionsAll,
			regions: state => state.regions.regions,
			materials: state => state.materials.materials,
			classification: state => state.workload.classification,
			staff: state => state.accounts.staff,
			customers: state => state.accounts.customers,
			customersTypes: state => state.entityType.customersTypes
		}),

		...mapGetters({
			getMaterialById: 'materials/getMaterialById'
		}),

		isAllFieldsEmpty(){
            return !this.regionIds.length === 0 && !this.fromDate && !this.toDate && !this.type && !this.name
        },

		iconCities () {
            if (this.selectedAllCities) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

		selectedAllCities () {
            return this.cityId.length === this.cities.length;
        },
	
		selectedAllRegions () {
            return this.regionIds.length === this.regionsAll.filter(c => this.cityId?.includes(c.cityId)).length;
        },

		icon () {
            if (this.selectedAllRegions) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

		headers () {
			const headers = [
				{
					text: 'المادة',
					name: 'materials',
					value: 'materialId',
					setValueExpr: val => this.getMaterialById(val)?.name
				},
				{
					text: 'الحساب',
					name: 'account',
					value: 'accountId',
					setValueExpr: val => this.customers.find(c => c.accountId === val)?.name
				},
				{
					text: 'الكمية الداخلة',
					name: 'in',
					value: 'totalIn'
				},
				// {
				// 	text: 'الكمية الخارجة',
				// 	name: 'out',
				// 	value: 'totalOut'
				// },
				{
					text: 'تاريخ آخر مناقلة',
					name: 'lastCreatedAt',
					value: 'lastCreatedAt',
					setValueExpr: val => moment(val).format('YYYY-MM-DD')
				},

				{
					text: 'مستلم من ',
					name: 'fromAccountIds',
					value: 'fromAccountIds',
					setValueExpr: val => val.map(c => this.staff.find(s => s.accountId === c)?.name).join(', ')
				}
			]
			return headers
		}	
	},

	methods: {
		moment,
		toggleCities () {
            this.$nextTick(() => {
                if (this.selectedAllCities) {
                    this.cityId = []
                    this.regionIds = []
                } 
                else {
                    this.cityId = this.cities.map(c => c.id);
                    this.setRegions()
                }
            })
        },

		setRegions () {
            this.regionIds = [];
            if (!this.cityId) return;
            this.regionsAll.forEach(region => {
                if (this.cityId.includes(region.cityId)) {
                    this.regionIds.push(region.id);
                }
            });
        },

		toggleReignsFilterItems () {
            this.$nextTick(() => {
                if (this.selectedAllRegions) {
                    this.regionIds = []
                } else {
                    this.regionIds = this.regionsAll.filter(c => this.cityId.includes(c.cityId)).map(c => c.id);
                }
            })
        },

		getStatistics() {
			this.loading = true
			this.$store.dispatch('statistics/fetchStatisticsWarehouse', {
				regionIds: this.regionIds.length ? this.regionIds : [],
				materialId: this.materialId, 
				fromDate: this.fromDate, 
				toDate: this.toDate,
				accountId: this.name,
				workloadIds: this.workloadIds,
				typeIds: this.type !== null ? [this.type] : [] 
			}).then((data) => {
				this.items = data
			}).finally(() => {
				this.loading = false
			})
		},

		fetchAccountCustomerByType () {
			// if (this.tab === 1) {
			this.submitLoading = true
			this.$store.dispatch('accounts/fetchAllBrief', { 
				type: accountTypeValue.customer, 
				entityTypeId: this.type, 
				regionIds: this.regionIds.length ? this.regionIds : [] 
			}).then((data) => {
				this.accountsBrief = data
			}).finally(() => {
				this.submitLoading = false
			})
			// }
		},

		reset () {
			this.cityId = []
			this.regionIds = []
			this.fromDate = null
			this.toDate = null
			this.type = null
			this.name = null
			this.materialId = null
			this.isSearch = false
			this.workloadId = null
		}
	},

	created () {
		this.loading = true
		Promise.all([
			!this.cities.length ? this.$store.dispatch('cities/fetchCityMine', {}) : null,
			!this.regionsAll.length ? this.$store.dispatch('regions/fetchAllRegions', {}) : null,
			
			!this.materials.length ? this.$requestStack.setRequest({
                key: 'materials/fetchAll',
                promise: this.$store.dispatch('materials/fetchAll', true)
            }) : this.$requestStack.getRequest('materials/fetchAll').promise,

			!this.classification.length ? this.$requestStack.setRequest({
                key: 'workload/fetchAll',
                promise: this.$store.dispatch('workload/fetchAll'),
            }) : this.$requestStack.getRequest('workload/fetchAll').promise,

			this.enableCustomerType && !this.customersTypes.length ? this.$store.dispatch('entityType/fetchAll') : null
		]).finally(() => {
			this.loading = false
		})
	}	
}
</script>
